import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Balasana = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Balasana.title1"), context: t("Balasana.context1") },
      { title: t("Balasana.title2"), context: t("Balasana.context2") },
      { title: t("Balasana.title3"), context: t("Balasana.context3") },
      { title: t("Balasana.title4"), context: t("Balasana.context4") },
      { title: t("Balasana.title5"), context: t("Balasana.context5") },
      { title: t("Balasana.title6"), context: t("Balasana.context6") },
      { title: t("Balasana.title7"), context: t("Balasana.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Balasana.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/balasana.mp4'}
                title="Description"
                context={t("Balasana.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Balasana
